import { render, staticRenderFns } from "./sensorConfigCard.vue?vue&type=template&id=6c7beffe&scoped=true"
import script from "./sensorConfigCard.vue?vue&type=script&lang=js"
export * from "./sensorConfigCard.vue?vue&type=script&lang=js"
import style0 from "./sensorConfigCard.vue?vue&type=style&index=0&id=6c7beffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7beffe",
  null
  
)

export default component.exports